// extracted by mini-css-extract-plugin
export default {"image":"image_image__-81vC"};